export default __webpack_public_path__ + "static/media/profiles.2c71eb8a.png";